import { BudgetRow } from "../components/budget/types";
import * as XLSX from 'xlsx';

export const exportBudgetRowToXLSX = (rows: BudgetRow[], months: string[], budgetName: string) => {
  const worksheet = XLSX.utils.aoa_to_sheet([
    ['Account', 'Description', ...months],
    ...rows.map(row => [
      row.number,
      row.description,
      ...months.map(month => row.amounts[month])
    ])
  ]);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Budget');
  XLSX.writeFile(workbook, `${budgetName}.xlsx`);
};
